import { Link } from 'react-router-dom';
import { Leaderboard } from '../components/Leaderboard.tsx';
import { AffiliateLeaderboard } from '../components/AffiliateLeaderboard.tsx';
import { usePromoConfig } from '../hooks/usePromoConfig.ts';
import { SEO } from '../components/SEO.tsx';

export function LeaderboardPage() {
  const { promoConfig } = usePromoConfig();

  const promoAllowsLeaderboard =
    promoConfig?.is_active &&
    promoConfig?.show_leaderboard &&
    ((promoConfig?.show_profit_leaderboard ?? true) ||
      (promoConfig?.show_affiliate_leaderboard ?? true));

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <SEO
        title="Leaderboard"
        description="Competition leaderboards on Wayja — track top traders and affiliates."
        url="/leaderboard"
      />
      <main className="flex-1 px-2 py-4 md:px-4 md:py-6 max-w-4xl mx-auto">
        <h1 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Leaderboard</h1>

        {!promoAllowsLeaderboard ? (
          <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6 text-center">
            <p className="text-gray-600 mb-4">
              There is no active competition leaderboard right now, or leaderboards are turned off.
            </p>
            <Link
              to="/markets"
              className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-wayja-teal text-white font-medium hover:bg-opacity-90 transition-colors"
            >
              Back to markets
            </Link>
          </div>
        ) : (
          <div className="space-y-4">
            {(promoConfig?.show_profit_leaderboard ?? true) && (
              <Leaderboard limit={10} showDetails={true} />
            )}
            {(promoConfig?.show_affiliate_leaderboard ?? true) && (
              <AffiliateLeaderboard limit={10} showDetails={true} />
            )}
          </div>
        )}
      </main>
    </div>
  );
}
